import React from 'react'
import { string, bool, node } from 'prop-types'

// to-do: make this wrapper shared component.
function SvgIcon({ customClass = '', isNotSpaced = true, children }) {
  const iconClass = `cgt-icon cgt-icon__icon
    ${isNotSpaced ? 'cgt-icon--not-spaced' : ''}
    ${customClass}`

  return <div className={iconClass}>{children}</div>
}

SvgIcon.propTypes = {
  customClass: string,
  children: node.isRequired,
  isNotSpaced: bool,
}

export default SvgIcon
